import React from "react";
import moment from "moment";
import { DATETIME_FORMAT_CLIENT } from "../../constants/main";

export const DateColumnTemplate = (props, field) => <div className="nowrap">
  {props[field] ? moment.utc(props[field]).local().format(DATETIME_FORMAT_CLIENT) : ''}
</div>;
